import { PACKAGE_KEY } from "goi_common";

export const PRIME = {
  "199": {
    M1: "PRIME199M1",
    S1: "PRIME199S1",
  },
  "259": {
    S1: "PRIME259S1",
    S2: "PRIME259S2",
    S2MUST: "PRIME259S2MUST",
    S2DC05: "PRIME259S2DC05",
    S2DC10: "PRIME259S2DC10",
    Y2: "PRIME259Y2",
    M1: "PRIME259M1",
    M2: "PRIME259M2",
    M3: "PRIME259M3",
    M4: "PRIME259M4",
    M990: "PRIME259M990",
    M4DC05: "PRIME259M4DC05",
    M4DC10: "PRIME259M4DC10",
    M4DC30: "PRIME259M4DC30",
    MS49: "PRIME259MS49",
    MS99: "PRIME259MS99",
    MS149: "PRIME259MS149",
    MS199: "PRIME259MS199",
    MS300: "PRIME259MS300",
    MS99MT: "PRIME259MS99MT",
  },
  "279": {
    M1: "PRIME279M1",
    S1: "PRIME279S1",
    M1DC05: "PRIME279M1DC05",
    M1DC10: "PRIME279M1DC10",
    S1DC05: "PRIME279S1DC05",
    S1DC10: "PRIME279S1DC10",
    M990: "PRIME279M990",
    MS99: "PRIME279MS99",
    MS99DC06: "PRIME279MS99DC06",
    MS99DC10: "PRIME279MS99DC10",
    MS99DC14: "PRIME279MS99DC14",
    MS99DC17: "PRIME279MS99DC17",
    MS99DC20: "PRIME279MS99DC20",
    MS99DC2D97: "PRIME279MS99DC2D97",
    MS99DC12D97: "PRIME279MS99DC12D97",
    MS198DC5D94: "PRIME279MS198DC5D94",
    S1M10DC20: "PRIME279S1M10DC20",
    S1M30DC40: "PRIME279S1M30DC40",
    MS279: "PRIME279MS279",
    MS279DC20: "PRIME279MS279DC20",
    MS558: "PRIME279MS558",
    MS558DC25: "PRIME279MS558DC25",
    M1DC14: "PRIME279M1DC14",
    S1DC14: "PRIME279S1DC14",
    M1DC15: "PRIME279M1DC15",
    S1DC15: "PRIME279S1DC15",
    MS99DC15: "PRIME279MS99DC15",
    M1AF2: "PRIME279M1AF2",
    M99AF2: "PRIME279M99AF2",
    S1AF2: "PRIME279S1AF2",
    MUST2509M1: "PRIME279MUST2509M1",
    MUST2509S1: "PRIME279MUST2509S1",
    MUST2510M1: "PRIME279MUST2510M1",
    MUST2510S1: "PRIME279MUST2510S1",
    M1HSV1: "PRIME279M1HSV1",
    M1HSV2: "PRIME279M1HSV2",
    S1HSV1: "PRIME279S1HSV1",
    S1HSV2: "PRIME279S1HSV2",
    MUST2511S1GDV: "PRIME279MUST2511S1GDV",
    MUST2511M1GDV: "PRIME279MUST2511M1GDV",
    M1PBK03: "PRIME279M1PBK03",
    S1PBK03: "PRIME279S1PBK03",
    M1PBK02: "PRIME279M1PBK02",
    S1PBK02: "PRIME279S1PBK02",
    M1PBK02V2: "PRIME279M1PBK02V2",
    S1PBK02V2: "PRIME279S1PBK02V2",
    M1TDT: "PRIME279M1TDT",
    M1DC10TDT: "PRIME279M1DC10TDT",
    MS99MT: "PRIME279MS99MT",
    S1MT: "PRIME279S1MT", // 추모테이블 3만원 일시납
    M1MT: "PRIME279M1MT", // 추모테이블 100원
    MS99DC2D97MT: "PRIME279MS99DC2D97MT", // 추모테이블 9900원 3개월면제
    M1DC10HSV: "PRIME279M1DC10HSV", // 홈쇼핑 100원 10만원할인
    S1DC10HSV: "PRIME279S1DC10HSV", // 홈쇼핑 3만원 10만원할인
    MS99DC12D97HSV: "PRIME279MS99DC12D97HSV", // 홈쇼핑 9900원 10만원할인+3개월면제
  },
  "289": {
    M1HBF: "PRIME289M1HBF",
    MS99DC12D97HBF: "PRIME289MS99DC12D97HBF",
    MS99DC2D97MTHBF: "PRIME289MS99DC2D97MTHBF",
    M1MTHBF: "PRIME289M1MTHBF",
    S1MTHBF: "PRIME289S1MTHBF",
    M1TDT: "PRIME289M1TDT",
    S1TDT: "PRIME289S1TDT",
    MS99DC12D97TDT: "PRIME289MS99DC12D97TDT",
    M1DC10TDT: "PRIME289M1DC10TDT",
    MS99MT: "PRIME289MS99MT",
    MS99DC2D97: "PRIME289MS99DC2D97",
    M1HP: "PRIME289M1HP", // 해피포인트 월 100원 정기납
    S1HP: "PRIME289S1HP", // 해피포인트 3만원 일시납
    MS99DC12D97HP: "PRIME289MS99DC12D97HP", // 해피포인트 월 9,900원 정기납
    MS99DC2D97N3: "PRIME289MS99DC2D97N3", // 26-e (9900원 전용 모델)
    S1N1: "PRIME289S1N1", // 26-f (3만원 일시납 전용 모델)
    MS99DC2D97MT: "PRIME289MS99DC2D97MT", // 카뱅 메모리얼: 289만원, 월9900원, 3개월면제
    MS99DC12D97MT: "PRIME289MS99DC12D97MT", // FOMO 재방문: 289만원, 월9900원, 10만원할인+메모리얼테이블
    M1MT: "PRIME289M1MT", // 추모테이블 100원
    S1MT: "PRIME289S1MT", // 추모테이블 3만원
    M1GAS: "PRIME289M1GAS", // 가스앱 100원
    S1GAS: "PRIME289S1GAS", // 가스앱 3만원
    MS99DC12D97GAS: "PRIME289MS99DC12D97GAS", // 가스앱 9900원 (3개월면제+10만할인)
    M1KB: "PRIME289M1KB", // 카카오뱅크 100원
    S1KB: "PRIME289S1KB", // 카카오뱅크 3만원
    MS99DC12D97KB: "PRIME289MS99DC12D97KB", // 카카오뱅크 9900원 (3개월면제+10만할인)
    M1MTGGR: "PRIME289M1MTGGR", // GGR 100원
    S1MTGGR: "PRIME289S1MTGGR", // GGR 3만원
    MS99DC2D97MTGGR: "PRIME289MS99DC2D97MTGGR", // GGR 9900원 (3개월면제+10만할인)
    M1MTMDY: "PRIME289M1MTMDY", // 모두의연결 100원
    S1MTMDY: "PRIME289S1MTMDY", // 모두의연결 3만원
    MS99DC2D97MTMDY: "PRIME289MS99DC2D97MTMDY", // 모두의연결 9900원 (3개월면제+10만할인)
    M1MTLPT: "PRIME289M1MTLPT", // 엘포인트 100원
    S1MTLPT: "PRIME289S1MTLPT", // 엘포인트 3만원
    MS99DC2D97MTLPT: "PRIME289MS99DC2D97MTLPT", // 엘포인트 9900원 (3개월면제+10만할인)
    M1MTOKC: "PRIME289M1MTOKC", // 오케이캐쉬백 100원
    S1MTOKC: "PRIME289S1MTOKC", // 오케이캐쉬백 3만원
    MS99DC2D97MTOKC: "PRIME289MS99DC2D97MTOKC", // 오케이캐쉬백 9900원 (3개월면제+10만할인)
    M1DC20: "PRIME289M1DC20", // 100원 월납 20만원 할인
    S1DC20: "PRIME289S1DC20", // 3만원 일시납 20만원 할인
    MS99DC22D97MT: "PRIME289MS99DC22D97MT", // 9900원 월납 20만원 할인 + 메모리얼테이블
    M1MTTDT: "PRIME289M1MTTDT", // 삼쩜삼 추모테이블 100원
    MS99MTTDT: "PRIME289MS99MTTDT", // 삼쩜삼 추모테이블 9900원
    MS99DC2D97TDT: "PRIME289MS99DC2D97TDT", // 삼쩜삼 추모테이블 9900원 3개월면제
    S1MTTDT: "PRIME289S1MTTDT", // 삼쩜삼 추모테이블 3만원 일시납
    M1RFR: "PRIME289M1RFR", // 레퍼리오 100원
    S1RFR: "PRIME289S1RFR", // 레퍼리오 3만원
    MS99DC2D97MTRFR: "PRIME289MS99DC2D97MTRFR", // 레퍼리오 9900원 (메모리얼테이블 포함)
    M1MTKPAY: "PRIME289M1MTKPAY", // 카카오페이 추모테이블 100원
    S1MTKPAY: "PRIME289S1MTKPAY", // 카카오페이 추모테이블 3만원
    MS99DC12D97MTKPAY: "PRIME289MS99DC12D97MTKPAY", // 카카오페이 9900원 (3개월면제+10만할인+추모테이블)
    M1MTKBANK: "PRIME289M1MTKBANK", // 카카오뱅크 추모테이블 100원
    S1MTKBANK: "PRIME289S1MTKBANK", // 카카오뱅크 추모테이블 3만원
    MS99DC12D97MTKBANK: "PRIME289MS99DC12D97MTKBANK", // 카카오뱅크 9900원 (3개월면제+10만할인+추모테이블)
  },
  "299": "PRIME299",
};

export const PRODUCT_GROUP = {
  "100": "100",
  "9900": "9900",
  mt: "mt",
  event_25g: "event_25g",
  event_25h: "event_25h",
  event_cws: "event_cws",
  "3-d-3": "3-d-3",
  adv: "adv",
  conducted: "conducted",
  hbf: "hbf",
  hp: "hp",
  gas: "gas",
  kakao_bank: "kakao_bank",
  ggr: "ggr",
  mdy: "mdy",
  lpt: "lpt",
  okc: "okc",
  rfr: "rfr",
  kpay: "kpay",
  kbank: "kbank",
};

export const LIVE_PRIME_PAY = {
  monthly: PACKAGE_KEY.PRIME["289"].M1,
  single: PACKAGE_KEY.PRIME["289"].S1,
  saving: PACKAGE_KEY.PRIME["289"].MS99DC2D97,
};

// 재방문 FOMO 고객 전용 상품 (혜택 동일, 가격 10만원 할인)
export const FOMO_LIVE_PRIME_PAY = {
  monthly: PACKAGE_KEY.PRIME["289"].M1DC10,
  single: PACKAGE_KEY.PRIME["289"].S1DC10,
  saving: PRIME["289"].MS99DC12D97MT,
};
